import { gql } from '@apollo/client'
import { ECrsType } from './bulkCreationModal/constants'

export interface IExportArtifactsWorkflowInput {
  resourceVersionIds: string[]
  config: {
    additionalFolders: string[]
    exportFormat: {
      type: 'shp'
      crs: ECrsType
    }
    requiredColumns: Record<string, string[]>
  }
}
export interface IFeatureExportWorkflowInput {
  layerName: string
  layerId: string
  clientId: string
}

export interface IImageryFeasibilityWorkflowInput {
  resourceVersionIds: string[]
  config: Record<string, any>
}

export interface IImageryPlaceOrderWorkflowInput {
  resourceVersionIds: Array<{
    id: string
    recommendedImageRequestId: string
  }>
}

export interface IExportSection {
  exportArtifactWorkflowInput: IExportArtifactsWorkflowInput
}

export interface IStartWorkflowPayload {
  createdBy: string
  requestType: string
  resourceVersions?: string[]
  resourceIds?: string[]
  pdPlanIngestionWorkflowInputs?: Array<{
    resourceVersions: string
    developmentPlanId: string
    lostFeaturePresent: boolean
  }>
  dsPluginRunWorkflowInputs?: Array<{
    resourceId: string
  }>
  exportArtifactWorkflowInput?: IExportArtifactsWorkflowInput
  featureExportWorkflowInput?: IFeatureExportWorkflowInput
  imageryFeasibilityWorkflowInputs?: IImageryFeasibilityWorkflowInput
  imageryPlaceOrderWorkflowInput?: IImageryPlaceOrderWorkflowInput
  pdArtifactExportWorkflowInputs?: Array<{
    resourceVersionId: string
    bngPlanId: string
  }>
  [key: string]: unknown
}

export interface IStartWorkflowInput {
  input: IStartWorkflowPayload
}

export interface IStartWorkflowOutput {
  startWorkflow: {
    success: boolean | null
  }
}

export const START_WORKFLOW = gql`
  mutation StartWorkflow($input: JSON!) {
    startWorkflow(input: $input)
      @rest(type: "StartWorkflow", path: "/workflow/start", method: "POST", bodyKey: "input") {
      success
    }
  }
`

export interface IWorkflowResultsInput {
  resourceVersionId: string
  workflowTypes: string[]
}

export interface IImageryFeasibilityRecord {
  year: number | null
  month: number | null
  firstCapture: string | null
  lastCapture: string | null
  credits: number
  coveragePercentage: number | null
  recommendedImageRequestId: string | null
}

export interface IImageryFeasibilityResult {
  recommendedImageRequestId: string
  records: IImageryFeasibilityRecord[]
}

export interface IImageryOrder {
  cloudPath: string
}

export interface IShapefileError {
  polygonId: string
  status: string
}

export interface IPipelineError {
  title: string
  errorCode: string | null
  errorDescription: string | null
  errorMessage: string | null
}

export interface IWorkflowResult {
  requestId: string
  resourceVersionId: string
  workflowType: string
  stage: string
  status: string
  metadata: any
  result: {
    imageryFeasibility?: IImageryFeasibilityResult[]
    imageryOrders?: IImageryOrder[]
    shapefileErrors?: IShapefileError[]
    pipelineErrors?: IPipelineError[]
    error?: string
  }
}

export const GET_WORKFLOW_RESULTS = gql`
  query GetWorkflowResults($resourceVersionId: UUID!, $workflowTypes: [String!]!) {
    getWorkflowResults(input: { resourceVersionId: $resourceVersionId, workflowTypes: $workflowTypes })
      @rest(
        type: "WorkflowResults"
        path: "/workflow/results"
        method: "POST"
        bodyKey: "input"
      ) {
      requestId
      resourceVersionId
      workflowType
      stage
      status
      metadata
      result
    }
  }
`

export interface ISiteClassificationOutput {
  [providedId: string]: 'DEFRA' | 'RAMBOL'
}
